let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j26Ur")).then(() => parcelRequire('6YaUi'));